<template>
  <div
    class="divider"
    :style="{
      '--divider-height': height || '0.5px',
      '--divider-margin': marginTop || '1.5rem',
    }"
  />
</template>

<script setup lang="ts">
defineProps<{
  height?: string
  marginTop?: string
}>()
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
  height: var(--divider-height);
  margin-top: var(--divider-margin);
  background: $gray-lighter;
}
</style>
